import { SYNC_LIMIT_LOW } from '@/utilities/constants';

import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import {
  BorerStateTypeCategoryDocument,
  borerStateTypeCategoryPullQueryBuilder,
} from './queryBuilder';

export function borerStateTypeCategoryFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<BorerStateTypeCategoryDocument> {
  const syncConfig = configBuilder<BorerStateTypeCategoryDocument>(
    RxdbCollectionNameV2.BORER_STATE_TYPE_CATEGORY,
  );
  doNotAutoSync(syncConfig);

  const pullConfig = pull(syncConfig, borerStateTypeCategoryPullQueryBuilder);
  pullConfig.batchSize = SYNC_LIMIT_LOW;

  const replicationState = replicate(syncConfig);
  // Legacy set syncInterval to LiveInterval.MINUTES_30
  return create(RxdbCollectionNameV2.BORER_STATE_TYPE_CATEGORY, replicationState, [sites]);
}
